import React, { SVGProps } from 'react';

function ActiveFollowUpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="3.5" y="3.5" width="18" height="18" rx="9" fill="#0F6C30" />
      <rect x="3.5" y="3.5" width="18" height="18" rx="9" stroke="#0F6C30" strokeWidth="2" />
      <mask id="mask0_6404_6074" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="5" y="5" width="15" height="15">
        <rect x="5.5" y="5.5" width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6404_6074)">
        <path d="M11.0708 14.3375L16.0146 9.39375C16.1312 9.27708 16.2673 9.21875 16.4229 9.21875C16.5785 9.21875 16.7146 9.27708 16.8312 9.39375C16.9479 9.51042 17.0062 9.64896 17.0062 9.80937C17.0062 9.96979 16.9479 10.1083 16.8312 10.225L11.4791 15.5917C11.3625 15.7083 11.2264 15.7667 11.0708 15.7667C10.9153 15.7667 10.7791 15.7083 10.6625 15.5917L8.15415 13.0833C8.03748 12.9667 7.98158 12.8281 7.98644 12.6677C7.9913 12.5073 8.05206 12.3688 8.16873 12.2521C8.2854 12.1354 8.42394 12.0771 8.58435 12.0771C8.74477 12.0771 8.88331 12.1354 8.99998 12.2521L11.0708 14.3375Z" fill="#FEFEFE" stroke="#FEFEFE" />
      </g>
    </svg>
  );
}

export default ActiveFollowUpIcon;
